import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { CadastroService } from 'src/app/services/cadastro.service';
import { ToastrService } from 'ngx-toastr';
import { AdesaoService } from 'src/app/services/adesao.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Subject } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { UtilService } from 'src/app/services/util.service';
import { EnderecoModel } from 'src/app/models/endereco.model';


@Component({
    selector: 'app-alt-endereco',
    templateUrl: './alt-endereco.component.html',
    styleUrls: ['./alt-endereco.component.css'],
    imports: [ReactiveFormsModule]
})
export class AltEnderecoComponent implements OnInit {

  form: FormGroup = null;

  endereco: any = null;
  msgErro: string = null;

  cidades: any[] = [];
  estados: any[] = [];

  loading: boolean = false;

  constructor(private cadastro: CadastroService, private toastr: ToastrService, private utilService: UtilService, private adesao: AdesaoService) { }

  ngOnInit() {
    this.listaEstado();
    this.carregarDados();
  }

  setForm(){

    let e: any = this.endereco;

    this.form = new FormGroup({
        cep: new FormControl(e.DCR_CEP, [Validators.required]),
        endereco: new FormControl(e.DCR_END, [Validators.required]),
        compl: new FormControl(e.DCR_COMPL, []),
        bairro: new FormControl(e.DCR_BAIRRO, [Validators.required]),
        uf: new FormControl(e.COD_UF, [Validators.required]),
        codCidade: new FormControl(e.COD_CIDADE, [Validators.required]),
        assinatura: new FormControl(null, [Validators.required])
    });

  }

  carregarDados(){

    this.cadastro
        .enderecoCarregar()
        .subscribe(
          (res: any) => {

            this.endereco = res;

            this.listarCidadesPorUF(res.COD_UF)
            .subscribe(next => {
              this.setForm();
            });

          },
          (error: HttpErrorResponse) => {

          }
        )
  }

  buscaCEP(cepValue: string): void {

    if (cepValue.length == 9){

      let cep = cepValue.replace('-','')

      this.utilService.buscaCep(cep).subscribe(
        (endereco: EnderecoModel) => {
          this.endereco.DCR_END = endereco.logradouro;
          this.endereco.DCR_COMPL = endereco.complemento;
          this.endereco.DCR_BAIRRO = endereco.bairro;
          this.endereco.COD_UF = endereco.uf;
          this.listarCidadesPorUF(this.endereco.COD_UF).subscribe(
            next => {
              let cidade = endereco.localidade.toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
              let objCidadeItem = this.cidades.find(item => item.DCR_CIDADE.includes(cidade));
              if(objCidadeItem != null){
                this.endereco.COD_CIDADE = objCidadeItem.COD_CIDADE;
              }else{
                alert("Município não cadastrado");
              }
              this.setForm();
            }
          );
          err => {
            alert("Ocorreu um erro ao buscar o CEP")
          }
        }
      )  
    }  
  }

  listaEstado(){
    this.adesao.ListarEstado()
    .subscribe(
      (res:any)=>{
        this.estados = res;
      }
    )
  }

  listaCidade(){
    this.adesao.ListarCidade()
    .subscribe(
      (res:any)=>{
        this.cidades = res;
      }
    )
  }

  onChangeUF(uf){
    this.listarCidadesPorUF(uf);
  }


  listarCidadesPorUF(codUF: string): Subject<any>{

    var subject = new Subject<any>();

    this.adesao.ListarCidadePorUf(codUF)
    .subscribe(
      (res: any[]) => {

        this.cidades = res;
        subject.next(res);

      },
      httpError => {
        console.error(httpError);
      }
    );
    return subject;
  }

  salvar(){

    this.loading = true;

    this.cadastro
        .enderecoSalvar(this.form.value)
        .pipe(
          finalize(() => { this.loading=false })
        )
        .subscribe(
          (res: boolean) => {

            if(res){
              this.toastr.success("Endereço alterados com sucesso");
              this.form.get("assinatura").setValue("");
            }

          },
          (error: HttpErrorResponse) => {

            this.msgErro = error.error.ex;

            setTimeout(()=>{
              this.msgErro = null;
            }, 5000);

          }
        )

  }

}
